import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { WealthManagementAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { TitleComponent } from '../../../common/components/TitleComponent'

import { HeaderSection, FooterSection, LeafBox, Accordion } from '@components'

import './WealthManagementDetail.scss'
const Container = styled.div`
  background-color: #ffffff;
  padding-top: 76px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const WealthManagementDetail = function () {
  const { t } = useTranslation()
  const { id } = useParams()
  const [data, setdata] = useState({})
  const [isLoading, setisLoading] = useState(false)

  const loadData = async function () {
    setisLoading(true)
    const reportData = await WealthManagementAPI(`/${id}`)
    setdata(reportData.data.data)
    setisLoading(false)
  }

  useEffect(() => {
    loadData()
  }, [])

  return (
    <Container>
      <TitleComponent title={data.title} />
      {!isLoading && (
        <div className="saving-detail">
          <Desktop>
            <HeaderSection
              title={data.title}
              group={t('solusi_masa_depan_anda')}
              description={data.description}
              banner={data.imageBannerDesktop}
              showButton={false}
            />
          </Desktop>
          <Mobile>
            <HeaderSection
              title={data.title}
              group={t('solusi_masa_depan_anda')}
              description={data.description}
              banner={data.imageBannerMobile}
              showButton={false}
            />
          </Mobile>

          <div className="p-0 m-0 container-fluid">
            <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
              {typeof data.keunggulanWealthManagement != 'undefined' &&
                data.keunggulanWealthManagement != '' && (
                  <div
                    className="keunggulan"
                    dangerouslySetInnerHTML={{
                      __html: data.keunggulanWealthManagement,
                    }}
                  ></div>
                )}

              {typeof data.dataBlockManfaat != 'undefined' &&
                data.dataBlockManfaat.length > 0 && (
                  <div>
                    <h2 className="mt-5 mb-4 section-title">
                      {t('solusi_tabungan_manfaat', {
                        tabungan: '',
                      })}
                    </h2>
                    <div className="row">
                      {data.dataBlockManfaat.map((item, index) => {
                        return (
                          <LeafBox
                            key={index}
                            size={4}
                            number={index + 1}
                            title={item.titleManfaatWealth}
                            description={item.descriptionManfaat}
                          />
                        )
                      })}
                    </div>
                  </div>
                )}

              {typeof data.dataBlockAccordion != 'undefined' &&
                data.dataBlockAccordion.length > 0 && (
                  <div className="mb-5">
                    <h2 className="mt-5 mb-4 section-title">
                      {t('solusi_tabungan_detail')}
                    </h2>
                    <div className="row">
                      {data.dataBlockAccordion.map((item, index) => {
                        return (
                          <Accordion key={index} title={item.titleAccordion}>
                            {item.contentAccordion}
                          </Accordion>
                        )
                      })}
                    </div>
                  </div>
                )}
              {data.disclaimer != null && data.disclaimer != '' && (
                <div className="mb-5">
                  <h2 className="mt-5 mb-4 section-title">Disclaimer</h2>
                  <div className="row">
                    <div className="col-12">
                      <p>{data.disclaimer}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <FooterSection currentPage={t('wealth_management')} />
    </Container>
  )
}

export default WealthManagementDetail
